// Copyright (c) Bentley Systems
import * as React from "react";
import { DawComponent } from "./daw-component";
import { DawComponentRoutePaths } from "./daw-component-route-paths";
import ManageAccessRolesAssignmentForm from "../SubscribedProjects/ManageAccessRolesAssignmentForm";

/**
 * Registry mapping component identifiers to their React components
 * Add new dynamic components here as they are created
 */
export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  [DawComponent.DAW_COMPONENT_MANAGE_ACCESS_ROLES_ASSIGNMENT_FORM]:
    ManageAccessRolesAssignmentForm,
  // Add more components here as needed
};

/**
 * Gets a component from the registry based on its identifier
 * @param identifier - The component identifier (e.g., "manageAccessRolesAssignment")
 * @returns The component class or null if not found
 */
export const getComponentByIdentifier = (
  identifier: string,
): React.ComponentType<any> | null => {
  const componentPath = `/${identifier}`;
  const componentKey = Object.keys(DawComponentRoutePaths).find(
    (key) =>
      DawComponentRoutePaths[key as keyof typeof DawComponentRoutePaths] ===
      componentPath,
  );

  return componentKey ? (COMPONENT_REGISTRY[componentKey] ?? null) : null;
};
